import "@/App.css";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import ScrollToTop from "@/components/ScrollToTop";
import SiteShell from "@/components/SiteShell";
import Home from "@/pages/Home";
import Marketing from "@/pages/Marketing";
import Audiovisual from "@/pages/Audiovisual";
import Proyectos from "@/pages/Proyectos";
import ProyectoDetalle from "@/pages/ProyectoDetalle";
import Actualidad from "@/pages/Actualidad";
import Contacto from "@/pages/Contacto";
import MockupIndex from "@/mockups/MockupIndex";
import MockupV1 from "@/mockups/V1";
import MockupV3 from "@/mockups/V3";
import V2Layout from "@/mockups/v2/V2Layout";
import V2Home from "@/mockups/v2/V2Home";
import V2Marketing from "@/mockups/v2/V2Marketing";
import V2Audiovisual from "@/mockups/v2/V2Audiovisual";
import V2Proyectos from "@/mockups/v2/V2Proyectos";
import V2Actualidad from "@/mockups/v2/V2Actualidad";
import V2Contacto from "@/mockups/v2/V2Contacto";

const ROUTES = [
  { path: "", element: <Home /> },
  { path: "marketing-comunicacion-eventos", element: <Marketing /> },
  { path: "produccion-audiovisual", element: <Audiovisual /> },
  { path: "proyectos", element: <Proyectos /> },
  { path: "proyectos/:slug", element: <ProyectoDetalle /> },
  { path: "actualidad", element: <Actualidad /> },
  { path: "contacto", element: <Contacto /> },
];

function buildRoute(prefix, r) {
  const full = "/" + [prefix, r.path].filter(Boolean).join("/");
  return <Route key={full || "/"} path={full || "/"} element={r.element} />;
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <LanguageProvider>
            <ScrollToTop />
            <Routes>
              {/* Standalone redesign mockups (no site header/footer) */}
              <Route path="/mockups" element={<MockupIndex />} />
              <Route path="/v1" element={<MockupV1 />} />
              <Route path="/v2" element={<V2Layout />}>
                <Route index element={<V2Home />} />
                <Route path="marketing" element={<V2Marketing />} />
                <Route path="audiovisual" element={<V2Audiovisual />} />
                <Route path="proyectos" element={<V2Proyectos />} />
                <Route path="actualidad" element={<V2Actualidad />} />
                <Route path="contacto" element={<V2Contacto />} />
              </Route>
              <Route path="/v3" element={<MockupV3 />} />
              {/* Current live site */}
              <Route
                path="/*"
                element={
                  <SiteShell>
                    <Routes>
                      {ROUTES.map((r) => buildRoute("", r))}
                      {ROUTES.map((r) => buildRoute("en", r))}
                    </Routes>
                  </SiteShell>
                }
              />
            </Routes>
          </LanguageProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
